import { NgModule } from '@angular/core';

import { AuthModule, ProductModule, ProductOccModule } from '@spartacus/core';

import {
  LoginRouteModule, NavigationEventModule, ProductDetailsPageModule, ProductListingPageModule,
  ProductPageEventModule, HomePageEventModule
} from '@spartacus/storefront';

import { CartBaseCoreModule, CartPageEventModule } from '@spartacus/cart/base/core';
import { CartBaseOccModule } from '@spartacus/cart/base/occ';
import { OrderOccModule } from '@spartacus/order/occ';

import { StoreFinderFeatureModule } from './features/store-finder-feature.module';
import { SmartEditFeatureModule } from './features/smart-edit-feature.module';
import { CheckoutFeatureModule } from './features/checkout-feature.module';
import { CommonFeatureModule } from './features/common-feature.module';
import { OrderFeatureModule } from './features/order-feature.module';
import { UserFeatureModule } from './features/user-feature.module';

@NgModule({
  imports: [
    // Auth Core
    AuthModule.forRoot(),
    LoginRouteModule,

    // Product Core
    ProductModule.forRoot(),
    ProductOccModule,
    ProductDetailsPageModule,
    ProductListingPageModule,

    // Cart Core
    CartBaseCoreModule,
    CartBaseOccModule,

    // Order
    OrderOccModule,

    // Page Events
    NavigationEventModule,
    HomePageEventModule,
    CartPageEventModule,
    ProductPageEventModule,

    UserFeatureModule,
    SmartEditFeatureModule,
    StoreFinderFeatureModule,
    CheckoutFeatureModule,
    OrderFeatureModule,

    // Common
    CommonFeatureModule
  ]
})
export class SpartacusFeaturesModule {}
